module.exports = __webpack_public_path__ + "img/about10.d40ad734.png";